import { render } from "./AdminApps.vue?vue&type=template&id=4aec3b11"
import script from "./AdminApps.vue?vue&type=script&lang=js"
export * from "./AdminApps.vue?vue&type=script&lang=js"

import "./AdminApps.vue?vue&type=style&index=0&id=4aec3b11&lang=css"

import exportComponent from "/home/pzborow/works/gunb/rwdzold/dev/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__